import { createAction } from '@reduxjs/toolkit';
import { OpenFastCheckoutAction, OpenPromocodeGiftModalAfterBuyAction } from 'reactApp/modules/payment/payment.types';

export const openFastCheckout = createAction<OpenFastCheckoutAction>('payment/openFastCheckout');
export const openPromocodeGiftModalAfterBuy = createAction<OpenPromocodeGiftModalAfterBuyAction>('payment/openPromocodeGiftModalAfterBuy');
